<script>
import { mapGetters } from 'vuex'

export default {
  props: { items: Array, selectedOrganization: Object },
  data: () => ({
    loading: false,
    selectedPermissions: []
  }),
  computed: {
    ...mapGetters(['permissionsList']),
    sanitizedItems: {
      get() {
        return this.items.map(item => item.permission)
      },
      set(value) {
        this.selectedPermissions = value
      }
    }
  },
  watch: {
    items: {
      handler() {
        this.selectedPermissions = []
      },
      deep: true
    },
    selectedPermissions(newVal) {
      newVal.length !== 0 &&
      this.$organizationService.updateOrganizationPermissions(newVal, this.selectedOrganization)
    }
  },
  methods: {
    remove(item) {
      this.selectedPermissions.splice(this.selectedPermissions.indexOf(item), 1)
    }
  }
}
</script>
<template>
  <v-combobox
    v-model="sanitizedItems"
    :items="permissionsList.sort()"
    :item-text="item => item.permission"
    :label="$t('component.backoffice.chipPermissions.global.permissions.label')"
    prepend-icon="mdi-filter-variant"
    variant="solo"
    chips
    clearable
    multiple>
    <template #selection="{ attrs, item }">
      <!--    <template #selection="{ attrs, item, select, selected }">-->
      <v-chip
        v-bind="attrs"
        :model-value="item"
        closable
        @click="remove(item)">
        {{ item }}
      </v-chip>
    </template>
  </v-combobox>
</template>
